import React from 'react'
import { UomTable } from './UomTable'
import _uomTable from './uomTable.json'

const uomTable = _uomTable as unknown as UomTable

export const splitUom = (uom: string) => {
  const match = /\d/g.exec(uom)
  if (!match) return [uom]

  // Split uom into numerator and denominator based on first occurrence of number
  const split = match.index
  let numerator, denominator
  // If the numberator is bracketed, adjust the indexes to exclude them
  if (uom.charAt(split + 1) === ']') {
    numerator = uom.substring(1, split + 1)
    denominator = uom.substring(split + 3)
  } else {
    numerator = uom.substring(0, split)
    denominator = uom.substring(split + 1)
  }

  // If the denominator is bracketed, adjust its indexes to exclude them
  if (denominator.includes('[')) {
    denominator = denominator.substring(1, denominator.indexOf(']'))
  // Else, just exclude the dashed exponent at the end
  } else {
    denominator = denominator.substring(0, denominator.indexOf('-'))
  }

  return [numerator, denominator]
}

export const parseUom = (uom: string) => {
  const tableRow = uomTable[uom]
  let components = tableRow ? tableRow.symbol.split('/') : splitUom(uom)

  let result: JSX.Element[] = []
  components.forEach((comp: string, i: number) => {
    if (!comp) return
    if (i > 0) result.push(<>/</>)

    const numberMatch = /\d/g.exec(comp)
    if (numberMatch) {
      result.push(<>{comp.substring(0, numberMatch.index)}</>)
      const exponent = comp.substring(numberMatch.index)
      if (exponent !== '1') {
        result.push(<sup>{exponent}</sup>)
      }
    } else {
      result.push(<>{comp}</>)
    }
  })

  return result
}